"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _history = require("history");

/**
 * A custom browser history object. We use this instead of
 * the default history React Router provides so that we can
 * expose parts of its functionality within a `useRouter()`
 * hook.
 * @package
 */
var history = typeof window !== "undefined" ? (0, _history.createBrowserHistory)() : function () {
  return null;
};
var _default = history;
exports["default"] = _default;